import { ChipiProvider } from './app-router/server/ChipiProvider';

export { ChipiProvider };

export type ServerComponentsServerModuleTypes = {
  ChipiProvider: typeof ChipiProvider;
};
